import { BaseController } from '../../base/controller';

class PositionsTableController extends BaseController {
  constructor(controllerService, $scope) {
    'ngInject';
    super({ controllerService, $scope });
  }

  $onInit() {
    this.transferPositions = {};
    this.show = false;
  }

  toggle() {
    this.show = !this.show;
  }
}

export default PositionsTableController;



// WEBPACK FOOTER //
// ./src/app/common/ui/positionsTable/positionsTable.controller.js